// eslint-disable-next-line import/no-unresolved
import { css } from 'styled-components';
import { media } from '../../../../helpers/mixins';
import { GRAY_TEXT } from '../../../../constants/colors';


export default {
  grayContainer: css`
    background-color: #d8d8d8;
    padding: 2% 15%;
    margin: auto;
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    width: 100%;
    ${media.md`
      display: grid;
      padding: 1% 2%;
      grid-template-columns: repeat(2, 1fr);
      width: 50%;`};
  `,
  labelInput: ({ color, size, weight }) => css`
  color: ${color || GRAY_TEXT};
  font-size: 15px;
  margin-top: 10px;
  margin-botom:30px;
  padding-left: 30px;
  font-weight: ${weight || 700} ;
  font-size: ${size || '15px'};
`,

  labelLight: ({ color, size }) => css`
    color: ${color || GRAY_TEXT};
    font-family: 'Open Sans', sans-serif;
    font-size: ${size || '15px'};
    // margin-top: 10px;
    padding-left: 30px;
    font-weight: 100;
  `,

  buttonContainer: css`
    display: flex;
    align-items: center;
    justify-content: center;
    ${media.md`
      justify-content: flex-end;
    `}
  `,
};
